import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaUsers, FaMotorcycle, FaClipboardList, FaRupeeSign } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';

const AdminBottomNavigation = () => {
  const location = useLocation();
  const { user } = useAuth();

  // Only show for admin users on admin pages
  if (user?.role !== 'admin' || !location.pathname.startsWith('/admin')) {
    return null;
  }

  // Don't show on admin login page
  if (location.pathname === '/admin/login') {
    return null;
  }

  const isActive = (path) => {
    if (path === '/admin') {
      return location.pathname === '/admin' || location.pathname === '/admin/';
    }
    return location.pathname.startsWith(path);
  };

  const navItems = [
    {
      path: '/admin',
      label: 'Dashboard',
      icon: FaHome,
      show: true
    },
    {
      path: '/admin/users',
      label: 'Users',
      icon: FaUsers,
      show: true
    },
    {
      path: '/admin/trips',
      label: 'Trips',
      icon: FaMotorcycle,
      show: true
    },
    {
      path: '/admin/bookings',
      label: 'Bookings',
      icon: FaClipboardList,
      show: true
    },
    {
      path: '/admin/payouts',
      label: 'Revenue',
      icon: FaRupeeSign,
      show: true
    }
  ].filter(item => item.show);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 md:hidden">
      <div className="flex justify-around items-center h-16 px-1 overflow-x-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 min-w-[60px] h-full relative ${
                active ? 'text-blue-600' : 'text-gray-500'
              }`}
            >
              <div className="relative">
                <Icon className={`text-xl ${active ? 'text-blue-600' : 'text-gray-500'}`} />
              </div>
              <span className={`text-xs mt-1 ${active ? 'text-blue-600 font-semibold' : 'text-gray-500'}`}>
                {item.label}
              </span>
              {active && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></div>
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default AdminBottomNavigation;

